import { render, staticRenderFns } from "./CrearEmpresa.vue?vue&type=template&id=24d678c4&scoped=true"
import script from "./CrearEmpresa.vue?vue&type=script&lang=js"
export * from "./CrearEmpresa.vue?vue&type=script&lang=js"
import style0 from "./CrearEmpresa.vue?vue&type=style&index=0&id=24d678c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d678c4",
  null
  
)

export default component.exports